import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'leaflet/dist/leaflet.css';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueScroll from '@david-j/vue-j-scroll';
Vue.config.productionTip = false

Vue.use(ElementUI)
   .use(VueScroll)
Vue.prototype.axios = axios

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
